import yup from '../../../config/yup';

export const lingkWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('lingkWriter'),
  delayedRead: yup.boolean(),
  format: yup.string(),
  properties: yup.object().shape({
    apiKey: yup.string(),
    apiSecret: yup.string(),
    apiEndpoint: yup.string().required('API Endpoint is required'),
  }),
});
